namespace SP.Data {
    export class Deadline {
        static async getDeadlineInfos() {
            var response = await SP.get<any>("/api/v1/info/deadlineInfos");
            if (response.status == 200) return response.data as SP.DeadlineInfo[];
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }
    }
}